import { productDetailReportValidate } from '../../application/dtos/product_detail_report_validate'

export class ProductDetailReportEntity {
    constructor({file}){
        this.file = file
    }

    isValid() {
        return productDetailReportValidate(this);
    }
}